module.exports = {
  prismicRepo: 'blir-varlden-battre',
  defaultLanguage: 'sv-se',
}
